import { EllipsisVertical } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { queryClient } from "@/libs/react-query";
import { useTranslation } from "react-i18next";

import { useDeleteNavigation } from "../api/delete-navigation";

type AddNavigationItemProps = {
  navigationId: string;
};

function DeleteNavigation(props: AddNavigationItemProps) {
  const { t } = useTranslation();
  const { mutateAsync: deleteNavigation, isPending } = useDeleteNavigation();

  const handleDeleteNavigationItem = async () => {
    await deleteNavigation({ menuId: props.navigationId });
    await queryClient.refetchQueries({
      queryKey: ["navigation"],
    });
    //TODO: handle server error
  };

  return (
    <Dialog>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            className="ml-auto size-7 rounded-full p-1"
            // aria-expanded={open}
            role="combobox"
          >
            <EllipsisVertical className="size-3.5" />
            <span className="sr-only">{t("navigationDelete.removeMenu")}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DialogTrigger asChild>
            <DropdownMenuItem className="cursor-pointer">
              {t("navigationDelete.delete")}
            </DropdownMenuItem>
          </DialogTrigger>
        </DropdownMenuContent>
      </DropdownMenu>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("navigationDelete.title")}</DialogTitle>
          <DialogDescription>
            {t("navigationDelete.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={isPending}>
              {t("navigationDelete.cancel")}
            </Button>
          </DialogClose>
          <DialogClose asChild>
            <Button onClick={handleDeleteNavigationItem} disabled={isPending}>
              {t("navigationDelete.confirm")}
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export { DeleteNavigation };
